export default __webpack_public_path__ + "static/media/connection_details.7dff15c3.PNG";